/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
class CartPropertyLabel extends HTMLElement {
  connectedCallback() {
    const hideFor = (this.dataset.hideFor || "")
      .split(",")
      .map((name) => name.trim().toLowerCase())
      .filter(Boolean);
 
    const name = this.querySelector("property-name")?.textContent.trim().toLowerCase();
 
    if (name && hideFor.includes(name)) this.hidden = true;
  }
}
 
if (!customElements.get("cart-property-label")) {
  customElements.define("cart-property-label", CartPropertyLabel);
}